// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"LoadingSpinner_backdrop__2yt4U","loading":"LoadingSpinner_loading__3yUdn","rotate":"LoadingSpinner_rotate__2T6DW"};